import { TableCell, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import * as React from "react";
import { HqType } from "../../../../../domain/models/daily-pob-report/dailypobreport";
import { DownloadJSON } from "../../../../../domain/models/daily-visit-report/downloadJSON";
import LeaveDataModal from "../Modal/LeaveDataModal";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

type Props = {
  open: boolean;
  hq: HqType;
  month: number;
  year: number;
  modal: Function;
  type: string;
  downloadJSON: DownloadJSON[];
  customerTypeId: string | null;
};

const CalendarGridPOBData: React.FC<Props> = ({
  open,
  hq,
  month,
  year,
  modal,
  type,
  downloadJSON,
}) => {
  const getDayOfWeek = (day: number) => {
    return new Date(year, month - 1, day).getDay();
  };
  const getDaysInMonth = () => {
    return new Date(year, month, 0).getDate(); 
  };
  const [total, setTotal] = useState<number>(0);
  const [openLeaveModal, setOpenLeaveModal] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [day, setDay] = useState<number>(0);
  const [leave, setLeave] = useState<string>("");
  const leaveModal = (
    day: number,
    user_id: number,
    name: string,
    leaveType: string
  ) => {
    setOpenLeaveModal((open) => !open);
    setName(name);
    setDay(day);
    setLeave(leaveType);
  };

  const hqJSON: any = {};
  hqJSON.role = "TSO";
  hqJSON.user = hq.tso_name;
  hqJSON.territory = hq.hq_name;

  useEffect(() => {
    let totalValue = 0;
    for (let day = 1; day <= getDaysInMonth(); day++) {
      const dataForDay = hq.monthly_data.find((item) => item.day === day);
      if (dataForDay) {
        if (type === "rupee" && dataForDay.rupees !== undefined) {
          totalValue += dataForDay.rupees;
        } else if (
          type === "order_count" &&
          dataForDay.order_count !== undefined
        ) {
          totalValue += dataForDay.order_count;
        } else if (type === "quantity" && dataForDay.quantity !== undefined) {
          totalValue += dataForDay.quantity;
        }
      }
    }

    setTotal(totalValue);
    hqJSON.total =
      type === "rupee" ? (totalValue / 100000).toFixed(1) : totalValue.toFixed(1);

    hqJSON.dailyPOBTarget =
      type === "rupee"
        ? (hq.daily_pob_target / 1000).toFixed(1)
        : hq.daily_pob_target;

    hqJSON.percentageToPOBTarget =
      hq.total_Pob && hq.hq_target && hq.hq_target !== 0
        ? `${((hq.total_Pob / hq.hq_target) * 100).toFixed(2)} %`
        : "0.0";

    for (let day = 1; day <= getDaysInMonth(); day++) {
      const dataForDay = hq.monthly_data.find((item) => item.day === day);
      const isSunday = getDayOfWeek(day) === 0;
      if (isSunday) {
        hqJSON[day] = "H";
      } else if (dataForDay && dataForDay.att_status === "working") {
        if (type === "rupee" && dataForDay.rupees !== undefined) {
          hqJSON[day] = (dataForDay.rupees / 1000).toFixed(1);
        } else if (
          type === "order_count" &&
          dataForDay.order_count !== undefined
        ) {
          hqJSON[day] = dataForDay.order_count;
        } else if (type === "quantity" && dataForDay.quantity !== undefined) {
          hqJSON[day] = dataForDay.quantity;
        }
      } else if (dataForDay && dataForDay.att_status === "leave") {
        hqJSON[day] = dataForDay.att_type
          ? dataForDay.att_type
              .split(" ")
              .map((word) => word[0])
              .join("")
          : "-";
      }
    }
  }, [hq, year, month, type]);

  const rowData = () => {
    const rows: JSX.Element[] = [];

    for (let day = 1; day <= getDaysInMonth(); day++) {
      const dataForDay = hq.monthly_data.find((item) => item.day === day);
      const isSunday = getDayOfWeek(day) === 0;
      if (dataForDay && dataForDay.att_status === "working") {
        rows.push(
          <Tooltip
            arrow
            title={
              <React.Fragment>
                <Typography sx={{ color: "#000080" }}>
                  Rupees = {dataForDay.rupees ? dataForDay.rupees : "0"}
                </Typography>
                <Typography sx={{ color: "#000080" }}>
                  Quantity = {dataForDay.quantity ? dataForDay.quantity : "0"}
                </Typography>
                <Typography sx={{ color: "#000080" }}>
                  Order Count ={" "}
                  {dataForDay.order_count ? dataForDay.order_count : "0"}
                </Typography>
              </React.Fragment>
            }
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#FFFFFF",
                  color: "#000080",
                  boxShadow: 3,
                  border: "1px solid #FF9933",
                  padding: "8px",
                },
              },
              arrow: {
                sx: {
                  color: "#FFFFFF",
                },
              },
            }}
          >
            <TableCell
              align="center"
              style={{
                border: "2px solid white",
                borderRadius: "2px",
                padding: 0,
                color: "#454545",
                cursor: isSunday ? "default" : "pointer",
                fontWeight: 550,
                backgroundColor: isSunday
                  ? "#d5dbe5"
                  : dataForDay.rupees !== undefined
                  ? dataForDay.rupees > hq.daily_pob_target
                    ? "#13c46f"
                    : dataForDay.rupees === 0
                    ? "#d1293d"
                    : "#f1c40f"
                  : "#f1c40f",
                fontSize: 10,
              }}
              onClick={() => {
                if (!isSunday) modal(day, hq.user_id, hq.tso_name, month, year);
              }}
            >
              {isSunday
                ? "H"
                : type === "rupee"
                ? dataForDay?.rupees !== undefined
                  ? (dataForDay.rupees / 1000).toFixed(1)
                  : 0
                : type === "order_count"
                ? dataForDay?.order_count !== undefined
                  ? dataForDay.order_count
                  : 0
                : type === "quantity"
                ? dataForDay?.quantity !== undefined
                  ? dataForDay.quantity
                  : 0
                : ""}
            </TableCell>
          </Tooltip>
        );
      } else if (dataForDay && dataForDay.att_status === "leave") {
        rows.push(
          <TableCell
            align="center"
            style={{
              border: "2px solid white",
              borderRadius: "2px",
              padding: 0,
              color: "white",
              cursor: isSunday ? "default" : "pointer",
              fontWeight: 550,
              backgroundColor: isSunday ? "#d5dbe5" : "#d1293d",
              fontSize: 10,
            }}
            onClick={() => {
              if (!isSunday && dataForDay.att_type)
                leaveModal(day, hq.user_id, hq.tso_name, dataForDay.att_type);
            }}
          >
            {dataForDay.att_type &&
              dataForDay.att_type
                .split(" ")
                .map((word) => word[0])
                .join("")}
          </TableCell>
        );
      } else if (
        dataForDay &&
        (dataForDay.att_status === "holiday" ||
          dataForDay.att_type === "Meeting")
      ) {
        rows.push(
          <TableCell
            align="center"
            style={{
              border: "2px solid white",
              padding: 0,
              cursor: "default",
              backgroundColor: "#d5dbe5",
              fontSize: 10,
            }}
          >
            {dataForDay.att_status === "holiday" ? "H" : "M"}
          </TableCell>
        );
      } else {
        rows.push(
          <TableCell
            align="center"
            style={{
              border: "2px solid white",
              padding: 0,
              cursor: "default",
              backgroundColor: isSunday ? "#d5dbe5" : "#edf6fc",
              fontSize: 10,
            }}
          >
            {isSunday ? "H" : ""}
          </TableCell>
        );
      }
    }
    return rows;
  };

  useEffect(() => {
    const existingIndex = downloadJSON.findIndex(
      (item) => item.user === hqJSON.user
    );
    if (existingIndex !== -1) {
      downloadJSON[existingIndex] = hqJSON;
    } else {
      downloadJSON.push(hqJSON);
    }
  }, [type, month, year]);

  return (
    <>
      <>
        {open && (
          <>
            <TableCell
              align="center"
              sx={{
                border: "2px solid white",
                padding: 0,
                backgroundColor: "#edf6fc",
              }}
            />

            <TableCell
              sx={{
                border: "2px solid white",
                padding: 0,
                width: 80,
                wordWrap: "break-word",
                overflowWrap: "break-word",
                fontSize: 12,
                backgroundColor: "#edf6fc",
              }}
            >
              {hq.tso_name}
            </TableCell>
            <TableCell
              padding="none"
              sx={{
                border: "2px solid white",
                padding: 0,
                width: 60,
                wordWrap: "break-word",
                overflowWrap: "break-word",
                fontSize: 12,
                textAlign: "center",
                backgroundColor: "#edf6fc",
              }}
            >
              {hq.hq_name}
            </TableCell>
            <TableCell
              align="center"
              sx={{
                border: "2px solid white",
                padding: 0,
                width: 40,
                fontSize: 12,
                backgroundColor: "#edf6fc",
              }}
            >
              {(hq.daily_pob_target / 1000).toFixed(1)}
            </TableCell>
            <TableCell
              align="center"
              sx={{
                border: "2px solid white",
                padding: 0,
                width: 40,
                fontSize: 12,
                backgroundColor: "#edf6fc",
              }}
            >
              {hq.total_Pob && hq.hq_target && hq.hq_target !== 0
                ? `${((hq.total_Pob / hq.hq_target) * 100).toFixed(1)} %`
                : "-"}
            </TableCell>
            <TableCell
              align="center"
              style={{
                border: "2px solid white",
                padding: 0,
                fontSize: 12,
                backgroundColor: "#edf6fc",
              }}
            >
              {hq.tso_status === "active" ? (
                <CheckCircleIcon
                  style={{ color: "green", fontSize: "small" }}
                />
              ) : (
                <CancelIcon style={{ color: "red", fontSize: "small" }} />
              )}
            </TableCell>
            <TableCell
              align="center"
              style={{
                border: "2px solid white",
                padding: 0,
                cursor: "default",
                fontSize: 12,
                backgroundColor: "#edf6fc",
              }}
            >
              {type === "rupee" ? (total / 100000).toFixed(1) : total}
            </TableCell>
            {rowData()}
          </>
        )}
      </>
      {openLeaveModal && (
        <LeaveDataModal
          open={openLeaveModal}
          setOpen={setOpenLeaveModal}
          day={day}
          month={month}
          year={year}
          name={name}
          leave={leave}
        />
      )}
    </>
  );
};

export default CalendarGridPOBData;
